import {PropsWithChildren} from "react";
import {css, cx} from "@panda/css";

import {KM_COMMON_TEST_IDS_MOBILE} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {HomeMatchOnboardingProvider} from "@/features/home_match/providers/HomeMatchOnboardingProvider";
import {HomeMatchPreferencesSurveyProvider} from "@/features/home_match/providers/HomeMatchPreferencesSurveyProvider";
import {kmFeatureFlagHomeMatch} from "@/features/km_app/utils/read_environment_variables";
import {Navigation} from "@/features/navigation/components/Navigation";
import {NavigationBottomNav} from "@/features/navigation/components/NavigationBottomNav";
import {useMobileBottomNavAutoHide} from "@/features/navigation/hooks/use_mobile_bottom_nav_auto_hide";
import {UserPhoneVerificationFlow} from "@/features/user/components/verifications/UserPhoneVerificationFlow";

const AuthenticatedLayoutContent = (props: PropsWithChildren) => {
    const {children} = props;

    const {isMobile} = useUserDevice();

    useMobileBottomNavAutoHide(Boolean(isMobile));

    return (
        <>
            <Navigation />

            <div
                className={cx(authenticatedContentOffsetStyle, isMobile && mobileContentPaddingStyle)}
                data-km-bottom-nav-follow={isMobile ? "padding" : undefined}
            >
                {children}
            </div>

            {isMobile && <NavigationBottomNav dataTestId={KM_COMMON_TEST_IDS_MOBILE.BOTTOM_NAV} />}

            <UserPhoneVerificationFlow />
        </>
    );
};

export const AuthenticatedLayout = (props: PropsWithChildren) => {
    const {children} = props;

    return (
        <HomeMatchPreferencesSurveyProvider>
            {kmFeatureFlagHomeMatch ? (
                <HomeMatchOnboardingProvider>
                    <AuthenticatedLayoutContent>{children}</AuthenticatedLayoutContent>
                </HomeMatchOnboardingProvider>
            ) : (
                <AuthenticatedLayoutContent>{children}</AuthenticatedLayoutContent>
            )}
        </HomeMatchPreferencesSurveyProvider>
    );
};

const authenticatedContentOffsetStyle = css({
    md: {
        ml: "28.8rem", // sidebar's 8px inset + 280px width
        width: "calc(100% - 28.8rem)"
    }
});

const mobileContentPaddingStyle = css({
    pt: "6rem"
});
import {PropsWithChildren} from "react";
import {css, cx} from "@panda/css";

import {KM_COMMON_TEST_IDS_MOBILE} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {HomeMatchOnboardingProvider} from "@/features/home_match/providers/HomeMatchOnboardingProvider";
import {HomeMatchPreferencesSurveyProvider} from "@/features/home_match/providers/HomeMatchPreferencesSurveyProvider";
import {kmFeatureFlagHomeMatch} from "@/features/km_app/utils/read_environment_variables";
import {Navigation} from "@/features/navigation/components/Navigation";
import {NavigationBottomNav} from "@/features/navigation/components/NavigationBottomNav";
import {useMobileBottomNavAutoHide} from "@/features/navigation/hooks/use_mobile_bottom_nav_auto_hide";
import {UserPhoneVerificationFlow} from "@/features/user/components/verifications/UserPhoneVerificationFlow";

const AuthenticatedLayoutContent = (props: PropsWithChildren) => {
    const {children} = props;

    const {isMobile} = useUserDevice();

    useMobileBottomNavAutoHide(Boolean(isMobile));

    return (
        <>
            <Navigation />

            <div
                className={cx(authenticatedContentOffsetStyle, isMobile && mobileContentPaddingStyle)}
                data-km-bottom-nav-follow={isMobile ? "padding" : undefined}
            >
                {children}
            </div>

            {isMobile && <NavigationBottomNav dataTestId={KM_COMMON_TEST_IDS_MOBILE.BOTTOM_NAV} />}

            <UserPhoneVerificationFlow />
        </>
    );
};

export const AuthenticatedLayout = (props: PropsWithChildren) => {
    const {children} = props;

    return (
        <HomeMatchPreferencesSurveyProvider>
            {kmFeatureFlagHomeMatch ? (
                <HomeMatchOnboardingProvider>
                    <AuthenticatedLayoutContent>{children}</AuthenticatedLayoutContent>
                </HomeMatchOnboardingProvider>
            ) : (
                <AuthenticatedLayoutContent>{children}</AuthenticatedLayoutContent>
            )}
        </HomeMatchPreferencesSurveyProvider>
    );
};

const authenticatedContentOffsetStyle = css({
    md: {
        ml: "28.8rem", // sidebar's 8px inset + 280px width
        width: "calc(100% - 28.8rem)"
    }
});

const mobileContentPaddingStyle = css({
    pt: "6rem"
});
